import React, { Component } from "react";
import PropTypes from "prop-types";

import i18n from "i18n-react";

import { Toast, StorageHandler } from "C4";
import { storageKeys } from "settings";

import dial from "assets/images/dial_question.png";

export default class TrainingDials extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedAnswerString: "",
      selectedAnswer: [],
      rotation: [],
      toastContent: null,
      profileImage: "",
    };
  }

  componentDidMount() {
    this.init();
    this.setHeader();
  }

  async setHeader() {
    // Load profile image image
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    const { questionHeader } = appInfo;
    this.setState({ profileImage: questionHeader });
  }

  init() {
    const { rotation, selectedAnswer } = this.state;
    const { amountOfDials } = this.props;
    let selectedAnswerString = amountOfDials === 3 ? "" : "0";
    for (let i = 0; i < amountOfDials; i += 1) {
      rotation.push(0);
      selectedAnswer.push(0);
      selectedAnswerString += 0;
    }
    this.setState({ rotation, selectedAnswer, selectedAnswerString });
  }

  updateDial(e) {
    e.preventDefault();
    const { id, children } = e.target;
    const { rotation, selectedAnswer } = this.state;

    if (e.type === "click") {
      children[1].style.transform = `rotate(${(rotation[id] += 36)}deg)`;
      if (selectedAnswer[id] < 9) {
        selectedAnswer[id] += 1;
      } else {
        selectedAnswer[id] = 0;
      }
    }

    if (e.type === "contextmenu") {
      children[1].style.transform = `rotate(${(rotation[id] -= 36)}deg)`;
      if (selectedAnswer[id] > 0) {
        selectedAnswer[id] -= 1;
      } else {
        selectedAnswer[id] = 9;
      }
    }

    let selectedAnswerString = "";
    selectedAnswer.forEach((answer) => {
      selectedAnswerString += answer;
    });
    if (selectedAnswerString.length === 2) {
      selectedAnswerString = `0${selectedAnswerString}`;
    }

    this.setState({ rotation, selectedAnswer, selectedAnswerString });
  }

  checkAnswers() {
    const { selectedAnswerString } = this.state;
    const {
      correctAnswer,
      contentComplete,
      incorrectAnswerText,
      correctAnswerText,
      error,
      amountOfDials,
    } = this.props;

    let isCorrect = false;
    if (
      amountOfDials === 3 &&
      selectedAnswerString === correctAnswer.toString()
    ) {
      isCorrect = true;
    } else if (
      amountOfDials === 2 &&
      selectedAnswerString.slice(-2) === correctAnswer.slice(-2)
    ) {
      isCorrect = true;
    }

    if (isCorrect) {
      this.setState({
        toastContent: {
          content: correctAnswerText,
          position: "top-center",
        },
      });
      contentComplete();
    } else {
      // this.setState({
      //   toastContent: {
      //     type: 'error',
      //     content: incorrectAnswerText,
      //     position: 'top-center',
      //   },
      // });
      error(true);
    }
  }

  renderDials(amount) {
    const dials = [];
    for (let i = 0; i < parseInt(amount, 10); i += 1) {
      const key = i;
      dials.push(
        <Dial
          number={this.state.selectedAnswer[key] || 0}
          onClick={(e) => {
            this.updateDial(e);
          }}
          id={key}
          key={key}
        />
      );
    }
    return dials;
  }

  render() {
    const { amountOfDials, question, disableHeader, error, disableToast } =
      this.props;

    const { toastContent, profileImage } = this.state;

    return (
      <div className="container__question">
        {!disableHeader && (
          <div
            className="container__question--image"
            style={{ backgroundImage: `url(${profileImage})` }}
          />
        )}
        <div className="container__question--content">
          <h4 className="container__title">{question}</h4>
          <div className="dials__wrapper">
            {this.renderDials(amountOfDials)}
          </div>
          {!disableToast && (
            <Toast
              trigger={toastContent !== null}
              onOpen={() => {
                this.setState({ toastContent: null });
              }}
              {...toastContent}
            />
          )}
          <button
            onClick={() => {
              this.checkAnswers();
            }}
          >
            {i18n.translate("trainingScreens.confirm")}
          </button>
        </div>
        {error(false)}
      </div>
    );
  }
}

const Dial = (props) => (
  <div
    className="dial"
    id={props.id}
    tabIndex={-1}
    role="button"
    onClick={(e) => {
      props.onClick(e);
    }}
    onKeyPress={(e) => {
      props.onClick(e);
    }}
    onContextMenu={(e) => {
      props.onClick(e);
    }}
  >
    <div className="number" id={`number_${props.id}`}>
      {props.number}
    </div>
    <img className="dial__image" src={`/${dial}`} alt="dial" />
  </div>
);

TrainingDials.propTypes = {
  amountOfDials: PropTypes.number.isRequired,
  contentComplete: PropTypes.func.isRequired,
  correctAnswer: PropTypes.string.isRequired,
  correctAnswerText: PropTypes.string,
  disableHeader: PropTypes.bool,
  error: PropTypes.func,
  incorrectAnswerText: PropTypes.string,
  question: PropTypes.string.isRequired,
  disableToast: PropTypes.bool,
};

TrainingDials.defaultProps = {
  correctAnswerText: "",
  disableHeader: false,
  error: () => {},
  incorrectAnswerText: "",
  disableToast: false,
};

Dial.propTypes = {
  id: PropTypes.number.isRequired,
  number: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
};
